const messageTitle = {
    UNEXPECTED_FORMAT: 'Unexpected data format received.',
    UNEXPECTED_ERROR: 'An unexpected error occurred.',
    NOT_FOUND: 'No record found.',
    FETCH_FAILED: 'Failed to fetch data. Please try again later.',
    TOKEN_NOT_FOUND: 'Access token not found!',
    TOKEN_EXPIRED: 'The refresh token has expired.',
    TOKEN_VALID: 'The access token is valid.',
    UNAUTHORIZED_LOGIN: 'Unauthorized! Redirecting to login...',
    TOKEN_ERROR: 'Error generating access token:',
    INTERCEPTOR_ERROR: 'Error in request interceptor:',
    FETCH_ERROR: 'Error fetching data:',
    ERROR_STATUS: 'HTTP error! status:',
    DATA_RECEIVED: 'Data received:',
    ACCESS_TOKEN: 'Access Token:',
    REFRESH_TOKEN: 'Refresh Token:',
  };

  const messageCode = {
    SUCCESS: 200,
    UNEXPECTED_FORMAT: 401,
    NOT_FOUND: 404
  };

  export const Message = {
    Title: messageTitle,
    Code: messageCode,
  }

  
